'use strict';

// Phone-only enhancement. Move existing content, retaining its handlers and IDs.
// Markers restore the exact desktop DOM when the viewport grows beyond 700px.
(() => {
  const phone = window.matchMedia('(max-width: 700px)');
  let teardown;

  function enhance() {
    const cleanups = [];
    const lifecycle = new AbortController();
    const signal = lifecycle.signal;
    const galleries = [];
    document.body.classList.add('mobile-shopping');

    function move(node, destination) {
      const marker = document.createComment('desktop position');
      node.before(marker);
      destination.append(node);
      cleanups.push(() => marker.replaceWith(node));
    }

    for (const [id, name] of [['organizers', 'Essential'], ['petite', 'Petite']]) {
      const section = document.getElementById(id);
      if (!section) continue;
      const editorial = section.querySelector('.organizer-editorial');
      const main = editorial.querySelector('.organizer-large');
      const support = editorial.querySelector('.organizer-side > img');
      const gallery = document.createElement('div');
      gallery.className = 'mobile-product-gallery';
      gallery.setAttribute('role', 'group');
      gallery.setAttribute('aria-label', `${name} photographs`);
      const track = document.createElement('div');
      track.className = 'mobile-photo-track';
      track.id = `${id}-mobile-photos`;
      track.tabIndex = 0;
      track.setAttribute('aria-label', `${name} photos. Swipe or use the left and right arrow keys.`);
      gallery.append(track);
      editorial.prepend(gallery);
      for (const [index, node] of [main, support].entries()) {
        const slide = document.createElement('div');
        slide.className = 'mobile-photo-slide';
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-label', `Photo ${index + 1} of 2`);
        track.append(slide);
        move(node, slide);
      }

      const controls = document.createElement('div');
      controls.className = 'mobile-photo-controls';
      const previous = document.createElement('button');
      previous.textContent = '←';
      previous.setAttribute('aria-label', `Previous ${name} photo`);
      const next = document.createElement('button');
      next.textContent = '→';
      next.setAttribute('aria-label', `Next ${name} photo`);
      for (const button of [previous, next]) {
        button.type = 'button';
        button.setAttribute('aria-controls', track.id);
      }
      const count = document.createElement('span');
      count.setAttribute('aria-live', 'polite');
      count.setAttribute('aria-atomic', 'true');
      controls.append(previous, count, next);
      gallery.append(controls);
      let current = 0;
      function update() {
        const distance = track.children[1].offsetLeft - track.children[0].offsetLeft;
        current = distance ? Math.min(1, Math.max(0, Math.round(track.scrollLeft / distance))) : 0;
        count.textContent = `${current + 1} / 2 · Swipe to explore`;
        previous.disabled = current === 0;
        next.disabled = current === 1;
      }
      function show(index) {
        const distance = track.children[1].offsetLeft - track.children[0].offsetLeft;
        track.scrollTo({left: Math.max(0, Math.min(1, index)) * distance, behavior:'instant'});
        update();
      }
      previous.addEventListener('click', () => show(current - 1), {signal});
      next.addEventListener('click', () => show(current + 1), {signal});
      track.addEventListener('scroll', update, {passive:true, signal});
      track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        show(event.key === 'Home' ? 0 : event.key === 'End' ? 1 : current + (event.key === 'ArrowRight' ? 1 : -1));
      }, {signal});
      update();
      galleries.push(gallery);
    }

    const wear = document.getElementById('riser-details');
    const finishDetails = document.querySelector('.finish-details');
    let details;
    if (wear && finishDetails) {
    details = document.createElement('details');
    details.className = 'mobile-wear-details';
    const summary = document.createElement('summary');
    summary.textContent = 'How to wear Risers';
    details.append(summary);
    finishDetails.querySelector('details').before(details);
    move(wear, details);

    function revealWearAnchor() {
      if (location.hash !== '#riser-details') return;
      details.open = true;
      requestAnimationFrame(() => {
        if (!signal.aborted) details.scrollIntoView({block:'start', behavior:'instant'});
      });
    }
    window.addEventListener('hashchange', revealWearAnchor, {signal});
    revealWearAnchor();
    }

    return () => {
      lifecycle.abort();
      // Restore moved content before removing temporary wrappers.
      cleanups.reverse().forEach(restore => restore());
      galleries.forEach(gallery => gallery.remove());
      details?.remove();
      document.body.classList.remove('mobile-shopping');
    };
  }

  function sync() {
    if (phone.matches && !teardown) teardown = enhance();
    else if (!phone.matches && teardown) {
      teardown();
      teardown = undefined;
    }
  }
  document.addEventListener('shopify:section:load', () => { if (teardown) teardown(); teardown = undefined; sync(); });
  document.addEventListener('shopify:section:unload', () => { if (teardown) teardown(); teardown = undefined; requestAnimationFrame(sync); });
  phone.addEventListener('change', sync);
  sync();
})();
